module.exports = __webpack_public_path__ + "static/media/PNT-logo.87ce0181.png";